import styled from "@emotion/styled";
import {breakpoints} from "assets/theme";

export const GameContainer = styled.div`
	max-width: 1080px;
	width: 100%;
	margin: 0 auto;
	padding: 0 12px;

	@media screen and (max-width: ${breakpoints.mobile}) {
		padding: 0 24px;
	}
`;

export const SmallContainer = styled.div`
	max-width: 320px;
	width: 100%;
`;

export const SummaryContainer = styled.div`
	margin: 0 auto;
	padding: 20px 16px;
	max-width: 440px;
	width: 100%;
`;

export const Center = styled.div`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
`;

export const FooterActionsWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	background: ${({theme}) => theme.colors.brand.black};
	padding: 8px 26px 23px 26px;
`;
export const FooterButtonsWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;

	&.summary {
		flex-direction: column;
		gap: 20px;
	}

	button span {
		min-width: 60px;
	}
`;

export const PopoverArrowBottom = styled.div`
	position: absolute;
	left: 50%;
	bottom: 0;
	transform: translate(-50%, 95%);

	width: 0;
	height: 0;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-top: 8px solid #ffffff;
`;
